import React from 'react';

import { EmailSupportLink } from '../../widgets/email-support-link';

export const CancellationExplanation = ({ variant }: { variant: 'fail' | 'success' }) =>
  variant === 'success' ? (
    <p>
      Your cancellation process has been initiated. Someone from our Customer Success team will be
      reaching out soon over email to confirm. We welcome any feedback you are willing to share
      about your experience with Team Engine!
    </p>
  ) : (
    <p>
      We encountered an error initiating your cancellation process. Please send an email to{' '}
      <EmailSupportLink /> to request your cancellation, or refresh the page and try again. Thank
      you for using Team Engine, we welcome any feedback you are willing to share!
    </p>
  );
